import React, { Component } from 'react'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'

import { Modal, DatePicker } from 'hljd'
import { observer } from 'mobx-react'
import ImgGallery from '@common/ImgGallery'
import moment from 'moment'

const MAX = 15

const formItemLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 }
}

@Form.create()
@observer
export default class extends Component {
  saveFinderActivity = e => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.store.createFinderActivity(values)
      }
    })
  }

  render() {
    const {
      form: { getFieldDecorator },
      store: {
        cancelCoverModal,
        coverModalVisible,
        removeImg,
        uploaded,
        imgs,
        selectedActivity
      }
    } = this.props
    const { start_date, end_date } = selectedActivity

    const total = imgs.length

    return (
      <Modal
        title="上传图片素材"
        visible={coverModalVisible}
        width={750}
        onOk={this.saveFinderActivity}
        onCancel={cancelCoverModal}
      >
        <Form>
          {!start_date &&
            !end_date && (
              <Form.Item labelAlign="left" {...formItemLayout} label="活动周期">
                {getFieldDecorator('time', {
                  rules: [{ required: true, message: '请设置活动周期' }]
                })(
                  <DatePicker.RangePicker
                    showTime={{
                      defaultValue: [
                        moment('00:00:00', 'HH:mm:ss'),
                        moment('23:59:59', 'HH:mm:ss')
                      ]
                    }}
                    placeholder={['起始时间', '截止时间']}
                  />
                )}
              </Form.Item>
            )}

          <p
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: 20
            }}
          >
            <span>
              请上传活动资源图，方便运营人员审核。（如需平台作图需提前7个工作日上传样片）
            </span>
            <span style={{ color: '#999' }}>
              {total}/{MAX}
            </span>
          </p>
          <ImgGallery
            showUpload={total < MAX}
            imgList={imgs}
            keyField="img"
            onOk={uploaded}
            onRemove={removeImg}
            max={MAX}
            style={{ marginLeft: -5 }}
            max_file_size="10mb"
            multiple={true}
          />
        </Form>
      </Modal>
    )
  }
}
